import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { Reveal } from "./motion";
import { IMG, wa } from "../lib/site";

const chips = ["Cataratas 🇧🇷", "Argentina 🇦🇷", "Paraguai 🇵🇾", "Tríplice Fronteira 🇧🇷🇦🇷🇵🇾"];

export default function FinalCTA() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section ref={ref} className="relative overflow-hidden grain" data-testid="final-cta-section">
      <motion.div style={{ y }} className="absolute inset-0 -top-[12%] -bottom-[12%]">
        <img src={IMG.hero} alt="Cataratas do Iguaçu ao entardecer" className="w-full h-full object-cover" loading="lazy" />
      </motion.div>
      <div className="absolute inset-0 bg-brand-deep/65" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-32 md:py-44">
        <Reveal>
          <p className="text-accent-soft text-xs font-semibold uppercase tracking-[0.35em]">Vai para Foz do Iguaçu?</p>
          <h2 className="mt-5 max-w-3xl font-display font-extrabold tracking-tight text-white text-3xl sm:text-4xl lg:text-6xl leading-[1.05] text-balance">
            Deixe seu passeio nas mãos de <span className="font-serif italic font-medium text-accent-soft">quem conhece Foz</span>
          </h2>
          <div className="mt-8 flex flex-wrap gap-3" data-testid="final-cta-chips">
            {chips.map((c) => (
              <span key={c} className="rounded-full border border-white/25 bg-white/10 backdrop-blur-md px-5 py-2.5 text-white/90 text-sm font-semibold">
                {c}
              </span>
            ))}
          </div>
          <p className="mt-8 max-w-xl text-white/85 text-base md:text-lg leading-relaxed">
            Conte para mim quando você estará em Foz e quantas pessoas estarão no grupo.
          </p>
          <a
            href={wa("Olá, Magnus! Vou para Foz do Iguaçu e quero planejar meus passeios. Data da viagem: ___ | Pessoas no grupo: ___")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-whatsapp-button"
            className="mt-10 inline-flex items-center gap-3 rounded-full bg-whatsapp px-10 py-5 text-base font-bold text-white shadow-2xl shadow-whatsapp/40 transition-transform duration-300 hover:scale-[1.05]"
          >
            <MessageCircle size={20} />
            Falar com o Magnus no WhatsApp
          </a>
        </Reveal>
      </div>
    </section>
  );
}
